module.exports = __webpack_public_path__ + "static/img/17-达实智能.73510271.png";